(function () {
  var grid = document.querySelector('.accolad-ucd-problem-grid');
  if (!grid) return;

  var cards = grid.querySelectorAll('.accolad-ucd-problem-card');
  if (cards.length === 0) return;

  if (grid.nextElementSibling && grid.nextElementSibling.classList.contains('accolad-uc-problem-dots')) return;

  var dotsContainer = document.createElement('div');
  dotsContainer.className = 'accolad-uc-problem-dots';
  dotsContainer.setAttribute('role', 'tablist');
  dotsContainer.setAttribute('aria-label', 'Navigation entre les problèmes');

  cards.forEach(function (card, index) {
    var dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'accolad-uc-problem-dot' + (index === 0 ? ' accolad-uc-problem-dot--active' : '');
    dot.setAttribute('data-index', String(index));
    dot.setAttribute('role', 'tab');
    dot.setAttribute('aria-label', 'Aller à la card ' + (index + 1));
    dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false');

    dot.addEventListener('click', function () {
      card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      setActive(index);
    });

    dotsContainer.appendChild(dot);
  });

  grid.insertAdjacentElement('afterend', dotsContainer);

  var dots = dotsContainer.querySelectorAll('.accolad-uc-problem-dot');

  function setActive(index) {
    dots.forEach(function (d, i) {
      d.classList.toggle('accolad-uc-problem-dot--active', i === index);
      d.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
  }

  // État actif basé sur la position de scroll : on retient la card dont le centre
  // est le plus proche du centre du track. Robuste aux largeurs min(90%, 360px),
  // au gap et au peek de la card suivante — contrairement à un IntersectionObserver
  // à seuil 0.5 où deux cards pouvaient être « actives » et la dernière l'emportait.
  function computeActiveIndex() {
    var trackRect = grid.getBoundingClientRect();
    var center = trackRect.left + trackRect.width / 2;
    var best = 0;
    var bestDist = Infinity;
    cards.forEach(function (card, i) {
      var r = card.getBoundingClientRect();
      var cardCenter = r.left + r.width / 2;
      var dist = Math.abs(cardCenter - center);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    });
    return best;
  }

  var rafId = null;
  grid.addEventListener('scroll', function () {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      setActive(computeActiveIndex());
    });
  }, { passive: true });

  // Init déterministe : point 1 actif une fois le layout flex/overflow stabilisé.
  requestAnimationFrame(function () { setActive(computeActiveIndex()); });
})();
